<header class="ds-header" (mouseleave)="closeMegaMenu()">
  <div class="ds-header-container">
    <!-- Mobile Sidebar Toggle Button (Orange) -->
    <button class="ds-mobile-sidebar-toggle"
      (click)="toggleSidebarEvent.emit()">
      <span class="burger-lines">
        <span class="burger-line"></span>
        <span class="burger-line"></span>
        <span class="burger-line"></span>
      </span>
    </button>

    <!-- Mobile Menu Burger Button (Teal) -->
    <button class="ds-mobile-burger"
      (click)="toggleMobileMenu($event)"
      [class.active]="isMobileMenuOpen">
      <span class="burger-lines">
        <span class="burger-line"></span>
        <span class="burger-line"></span>
        <span class="burger-line"></span>
      </span>
    </button>

    <!-- Main Navigation -->
    <nav class="ds-header-nav">
      <ul class="ds-nav-list">
        @for (item of menuItems; track item) {
          <li
            class="ds-nav-item"
            [class.active]="isMenuItemActive(item)"
            [class.has-mega-menu]="item.megaMenu"
            (mouseenter)="item.megaMenu ? openMegaMenu(item.label) : null">
            <!-- Direct Link (no mega menu) -->
            @if (!item.megaMenu && item.routerLink) {
              <a
                [routerLink]="item.routerLink"
                class="ds-nav-link"
                routerLinkActive="active">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                <span>{{ item.label }}</span>
              </a>
            }
            <!-- Mega Menu Trigger -->
            @if (item.megaMenu) {
              <a
                class="ds-nav-link ds-nav-trigger"
                [class.active]="isMenuItemActive(item)"
                (click)="toggleMegaMenu(item.label, $event)">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                <span>{{ item.label }}</span>
                <i class="pi pi-chevron-down ds-chevron"></i>
              </a>
            }
          </li>
        }
      </ul>

      <!-- Mega Menu Panel -->
      @if (activeMenu) {
        <div
          class="ds-mega-menu-panel"
          [@slideDown]
          (mouseleave)="closeMegaMenu()">
          <div class="ds-mega-menu-content">
            <div class="ds-mega-menu-sections">
              @for (item of menuItems; track item) {
                @if (item.label === activeMenu && item.megaMenu) {
                  @for (section of item.megaMenu; track section) {
                    <div
                      class="ds-mega-menu-section"
                      [class.featured]="section.featured">
                      <h4 class="ds-section-title">{{ section.title }}</h4>
                      <ul class="ds-section-links">
                        @for (link of section.items; track link) {
                          <li>
                            <a [routerLink]="link.routerLink"
                              class="ds-mega-link"
                              routerLinkActive="active"
                              (click)="closeMegaMenu()">
                              @if (link.icon) {
                                <i [class]="link.icon"></i>
                              }
                              <div class="ds-link-content">
                                <span class="ds-link-label">{{ link.label }}</span>
                                @if (link.description) {
                                  <span class="ds-link-description">
                                    {{ link.description }}
                                  </span>
                                }
                              </div>
                            </a>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                }
              }
            </div>
          </div>
        </div>
      }
    </nav>

    <!-- Right Section -->
    <div class="ds-header-actions">
      <!-- Switch Account Widget -->
      <div class="ds-switch-widget">
        <div class="ds-switch-icon-wrap">
          <i class="fa fa-exchange"></i>
        </div>
        <div class="ds-switch-dropdowns">
          <p-dropdown [options]="roles" [(ngModel)]="selectedRole" [placeholder]="'dsAdminHeader.selectRole' | transloco"
            (onChange)="onSelectRole($event)" appendTo="body" styleClass="ds-role-dropdown" panelStyleClass="ds-role-dropdown-panel">
          </p-dropdown>
          @if (isDropdownOpen) {
            <p-dropdown [options]="dropDownData" (onChange)="onSelectId($event)"
              optionLabel="label" [filter]="true" filterBy="label" [showClear]="true" appendTo="body"
              [(ngModel)]="selectedEntity" [placeholder]="getPlaceholderText()" styleClass="ds-entity-dropdown" panelStyleClass="ds-entity-dropdown-panel">
              <ng-template let-group pTemplate="item">
                <div class="ds-entity-item">
                  <img [src]="group.data?.imgUrl ? group.data.imgUrl : 'assets/images/No-Image.png'"
                    class="ds-entity-avatar" />
                  <span class="ds-entity-name">
                    @if (!group.data?.businessName) {
                      {{ group.label }}
                    }
                    @if (group.data?.businessName) {
                      {{ group.data?.businessName }}
                    }
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          }
        </div>
      </div>

      <!-- Notifications Icon -->
      <div class="ds-notification-icon">
        <button (click)="onToggleNotifications($event)" class="ds-icon-btn">
          <i class="fa fa-bell"></i>
          @if (countUnreadNotificaion) {
            <span class="ds-badge">{{ countUnreadNotificaion }}</span>
          }
        </button>
        @if (showNotifications) {
          <div class="ds-notification-dropdown">
            @if (isLoadingNotifications) {
              <div class="ds-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
            }
            @for (notification of notifications.slice(0, 5); track notification) {
              <div class="ds-notification-item" (click)="onHandleNotificationClick(notification)">
                <i class="fa fa-bell ds-notification-icon-small" [class.text-success]="notification.IsRead" [class.text-danger]="!notification.IsRead"></i>
                <div class="ds-notification-content">
                  <div class="ds-notification-header">
                    <span class="ds-notification-name">{{ notification.Title }}</span>
                  </div>
                  <p class="ds-notification-body">{{ notification.Body | slice:0:60 }}...</p>
                </div>
              </div>
            }
            @if (notifications.length > 5) {
              <div class="ds-notification-footer">
                <a (click)="onNavigateToNotificationsList()">{{ 'dsAdminHeader.seeAllNotifications' | transloco }}</a>
              </div>
            }
            @if (notifications.length === 0 && !isLoadingNotifications) {
              <div class="ds-notification-empty">
                {{ 'dsAdminHeader.noNotifications' | transloco }}
              </div>
            }
          </div>
        }
      </div>

      <!-- Language Switcher -->
      <app-language-switcher class="ds-lang-switcher me-2"></app-language-switcher>

      <!-- User Avatar Dropdown -->
      @if (authUser) {
        <div class="ds-user-menu">
          <button class="ds-user-avatar"
            (click)="toggleUserMenu($event)"
            [class.active]="isUserMenuOpen">
            <img [src]="authUser.PersonalImgUrl || authUser.LogoUrl || 'assets/images/default-avatar.png'"
              (error)="$any($event.target).src='assets/images/No-Image.png'"
              [alt]="userFullName"
              height="40" />
          </button>
          @if (isUserMenuOpen) {
            <div class="ds-user-dropdown" (click)="$event.stopPropagation()">
              <div class="ds-user-info">
                <div class="ds-user-avatar-large">
                  <img [src]="authUser.PersonalImgUrl || authUser.LogoUrl || 'assets/images/default-avatar.png'"
                    (error)="$any($event.target).src='assets/images/No-Image.png'"
                    [alt]="userFullName" />
                </div>
                <div class="ds-user-details">
                  <span class="ds-user-name">{{ userFullName }}</span>
                  <span class="ds-user-email">{{ authUser.EmailAddress }}</span>
                </div>
              </div>
              @if (planDisplayText) {
                <div class="ds-plan-badge">
                  <span class="ds-plan-label">{{ 'dsAdminHeader.role' | transloco }}</span>
                  <span class="ds-plan-value">{{ planDisplayText }}</span>
                </div>
              }
              <div class="ds-dropdown-divider"></div>
              <nav class="ds-user-nav">
                <a class="ds-user-nav-item" routerLink="/edit-profile" (click)="closeUserMenu()">
                  <i class="pi pi-user"></i>
                  <span>{{ 'dsAdminHeader.myProfile' | transloco }}</span>
                </a>
                <!-- TEMPORARY: nav-migration "all pages" directory. Remove with the new nav. -->
                <a class="ds-user-nav-item" routerLink="/all-pages" (click)="closeUserMenu()">
                  <i class="pi pi-list"></i>
                  <span>All pages</span>
                </a>
              </nav>
              <div class="ds-dropdown-divider"></div>
              <div class="ds-user-actions">
                <a class="ds-user-nav-item ds-sign-out" href="#" (click)="logout($event)">
                  <i class="pi pi-sign-out"></i>
                  <span>{{ 'dsAdminHeader.signOut' | transloco }}</span>
                </a>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Overlay for closing mega menu -->
  @if (activeMenu) {
    <div
      class="ds-mega-menu-overlay"
    (click)="closeMegaMenu()"></div>
  }

  <!-- Overlay for closing user menu -->
  @if (isUserMenuOpen) {
    <div
      class="ds-user-menu-overlay"
    (click)="closeUserMenu()"></div>
  }

  <!-- Mobile Menu Panel -->
  <div class="ds-mobile-menu" [class.open]="isMobileMenuOpen">
    <div class="ds-mobile-menu-header">
      <span class="ds-mobile-menu-title">{{ 'dsAdminHeader.adminMenu' | transloco }}</span>
      <button class="ds-mobile-close" (click)="closeMobileMenu()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <nav class="ds-mobile-nav">
      <ul class="ds-mobile-nav-list">
        @for (item of menuItems; track item) {
          <li class="ds-mobile-nav-item">
            <!-- Direct Link -->
            @if (!item.megaMenu && item.routerLink) {
              <a
                [routerLink]="item.routerLink"
                class="ds-mobile-nav-link"
                routerLinkActive="active"
                (click)="closeMobileMenu()">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                <span>{{ item.label }}</span>
              </a>
            }
            <!-- Expandable Menu Item -->
            @if (item.megaMenu) {
              <div class="ds-mobile-expandable">
                <button class="ds-mobile-nav-link ds-mobile-expand-trigger"
                  (click)="toggleMobileSubMenu(item.label)"
                  [class.expanded]="expandedMobileMenu === item.label">
                  @if (item.icon) {
                    <i [class]="item.icon"></i>
                  }
                  <span>{{ item.label }}</span>
                  <i class="pi pi-chevron-down ds-mobile-chevron"></i>
                </button>
                @if (expandedMobileMenu === item.label) {
                  <div class="ds-mobile-submenu">
                    @for (section of item.megaMenu; track section) {
                      <div class="ds-mobile-section">
                        <span class="ds-mobile-section-title">{{ section.title }}</span>
                        <ul class="ds-mobile-section-links">
                          @for (link of section.items; track link) {
                            <li>
                              <a [routerLink]="link.routerLink"
                                class="ds-mobile-sublink"
                                routerLinkActive="active"
                                (click)="closeMobileMenu()">
                                @if (link.icon) {
                                  <i [class]="link.icon"></i>
                                }
                                <span>{{ link.label }}</span>
                              </a>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </li>
        }
      </ul>
    </nav>
  </div>

  <!-- Mobile Menu Overlay -->
  @if (isMobileMenuOpen) {
    <div
      class="ds-mobile-menu-overlay"
    (click)="closeMobileMenu()"></div>
  }
</header>
